import React from 'react';
import TableBook from '../component/book/TableBook';
import Footer from '../component/Footer';
export default function Book()
{
return(
  <div class="sub_page">
      <TableBook />
      <Footer />
  </div>
)
}